import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/productPlan/QueryPage'
export const Download = '/icps/system/sign/dataCollection/productPlan/exportExamineAndApprove'
/*修改或提交计划*/
export function okOrTurnDown(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/okOrTurnDown', //接收和拒绝
    method: 'post',
    data
  })
}
export function getPlanDetail(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/getPlanDetail', //接收和拒绝
    method: 'post',
    data
  })
}
export function QueryStatistics() {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/statisticsPurchase', //采购总量、list
    method: 'post',
  })
}